var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"fixed-tabs":"","background-color":"indigo","dark":""}},[_c('v-tab',[_vm._v(" Option ")]),_c('v-tab',[_vm._v(" Another Selection ")]),_c('v-tab',[_vm._v(" Items ")]),_c('v-tab',[_vm._v(" Another Screen ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }